const richTextLinkToLinkObject = props => ({
  ...(props || {}),
  url: props?.href,
  cached_url: props?.href,
  target: props?.target,
});

export {richTextLinkToLinkObject};
